/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AUSpinnerComponent from '@aarhus-university/au-lib-react-components/src/components/AUSpinnerComponent';
import BoxComponent from '../components/BoxComponent';
import SearchComponent from '../components/SearchComponent';
import getGroupings from '../actions/getGroupings';
import getItems from '../actions/getItems';
import clear from '../actions/clear';
import '../styles/styles.scss';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSubjects: !sessionStorage.getItem('gym-selected') ? [] : JSON.parse(sessionStorage.getItem('gym-selected')),
    };

    this.setSelectedSubjects = this.setSelectedSubjects.bind(this);
  }

  setSelectedSubjects(selectedSubjectsParameter, clearSelected = false) {
    const { selectedSubjects } = this.state;
    const ss = [];

    if (!clearSelected) {
      const currentChecked = selectedSubjects.filter((x) => x.Checked);
      selectedSubjectsParameter.forEach((s) => {
        if (s.Checked) {
          let found = false;
          currentChecked.forEach((x) => {
            if (s.ID === x.ID) {
              found = true;
            }
          });
          if (!found) {
            ss.push(s);
          }
        }
      });

      currentChecked.forEach((x) => {
        let found = false;
        selectedSubjectsParameter.forEach((s) => {
          if (x.ID === s.ID) {
            ss.push(x);
            found = true;
          }
        });
        if (!found) {
          ss.push(x);
        }
      });
    }

    this.setState({ selectedSubjects: ss }, () => {
      // sessionStorage.setItem('gym-selected', JSON.stringify(ss));
    });
  }

  render() {
    const { activities, actions } = this.props;
    const { selectedSubjects } = this.state;
    const items = activities.FilteredItems;
    const allSubjectActivities = items.filter((x) => x.AllSubjects);
    const activitiesFromState = selectedSubjects.length > 0
      ? items.filter((x) => !x.AllSubjects) : items;
    const renderSelectedSubjects = selectedSubjects.map((s, i) => {
      const delim = i <= selectedSubjects.length - 2 ? ', ' : '';
      const key = i;
      return (
        <span key={key}>
          {s.Name}
          {delim}
        </span>
      );
    });

    const allSubjectActElements = allSubjectActivities.map((act) => (
      <BoxComponent key={act.ID} activity={act} />
    ));

    const actElements = activitiesFromState.map((act) => (
      <BoxComponent key={act.ID} activity={act} />
    ));

    return (
      <div className="row">
        <AUSpinnerComponent
          loaded={activities.Items.length > 0}
          loadingCondition={activities.Items.length === 0}
          onLoad={() => {
            actions.getGroupings();
            actions.getItems('', '', true);
          }}
        >
          <div className="column large-12 medium-12 small-12">
            <SearchComponent
              items={items}
              groupings={activities.Groupings}
              getItems={actions.getItems}
              setSelectedSubjects={this.setSelectedSubjects}
            />
            {(() => {
              if (selectedSubjects.length > 0 && activitiesFromState.length > 0) {
                return (
                  <div className="row">
                    <div className="column large-12 medium-12 small-12">
                      <h3 className="activity-count">
                        {'Aktiviteter for de(t) valgte fag ('}
                        {renderSelectedSubjects}
                        {'):'}
                      </h3>
                    </div>
                  </div>
                );
              }
              if (selectedSubjects.length > 0) {
                return (
                  <div className="row">
                    <div className="column large-12 medium-12 small-12">
                      <h3 className="activity-count">
                        {'Ingen specifikke aktiviteter for de(t) valgte fag ('}
                        {renderSelectedSubjects}
                        {')'}
                      </h3>
                    </div>
                  </div>
                );
              }
              return null;
            })()}
            {(() => {
              if (activitiesFromState.length > 0) {
                return (
                  <div className="row gym-activities">
                    {actElements}
                  </div>
                );
              }
              return null;
            })()}
            {(() => {
              if (selectedSubjects.length > 0) {
                return (
                  <div className="row">
                    <div className="column large-12 medium-12 small-12">
                      <h3 className="activity-count">
                        {'Aktiviteter for alle fag: '}
                      </h3>
                    </div>
                  </div>
                );
              }
              return null;
            })()}
            {(() => {
              if (selectedSubjects.length > 0) {
                return (
                  <div className="row gym-activities">
                    {allSubjectActElements}
                  </div>
                );
              }
              return null;
            })()}
          </div>
        </AUSpinnerComponent>
      </div>
    );
  }
}

AppComponent.propTypes = {
  actions: PropTypes.shape({
    getGroupings: PropTypes.func.isRequired,
    getItems: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
  }).isRequired,
  activities: PropTypes.shape({
    Groupings: PropTypes.arrayOf(PropTypes.shape({
      Active: PropTypes.bool.isRequired,
      AssociationContainers: PropTypes.arrayOf(PropTypes.shape({
        Associations: PropTypes.arrayOf(PropTypes.shape({
          Active: PropTypes.bool.isRequired,
          DataListGroupings: PropTypes.arrayOf(PropTypes.shape({})),
          DataListItems: PropTypes.arrayOf(PropTypes.shape({})),
          GroupID: PropTypes.number.isRequired,
          Name: PropTypes.string.isRequired,
        }).isRequired).isRequired,
        ID: PropTypes.number.isRequired,
        Name: PropTypes.string.isRequired,
      }).isRequired).isRequired,
      DataList: PropTypes.any,
      DataListAssociations: PropTypes.array,
      GroupOrder: PropTypes.number.isRequired,
      ID: PropTypes.number.isRequired,
      List: PropTypes.number.isRequired,
      Name: PropTypes.string.isRequired,
    }.isRequired).isRequired),
    Items: PropTypes.arrayOf(PropTypes.shape({
      AllSubjects: PropTypes.bool.isRequired,
      Associations: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
      Description: PropTypes.string,
      EndDate: PropTypes.string,
      ID: PropTypes.number.isRequired,
      Location: PropTypes.string,
      Name: PropTypes.string.isRequired,
      NameTrim: PropTypes.string.isRequired,
      Occurrence: PropTypes.string,
      Price: PropTypes.string,
      Provider: PropTypes.string,
      SubCategory: PropTypes.string,
      Subject: PropTypes.string,
      Target: PropTypes.string,
      Type: PropTypes.string.isRequired,
      Url: PropTypes.string.isRequired,
    }).isRequired),
    FilteredItems: PropTypes.arrayOf(PropTypes.shape({
      AllSubjects: PropTypes.bool.isRequired,
      Associations: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
      Description: PropTypes.string,
      EndDate: PropTypes.string,
      ID: PropTypes.number.isRequired,
      Location: PropTypes.string,
      Name: PropTypes.string.isRequired,
      NameTrim: PropTypes.string.isRequired,
      Occurrence: PropTypes.string,
      Price: PropTypes.string,
      Provider: PropTypes.string,
      SubCategory: PropTypes.string,
      Subject: PropTypes.string,
      Target: PropTypes.string,
      Type: PropTypes.string.isRequired,
      Url: PropTypes.string.isRequired,
    }).isRequired),
  }).isRequired,
};

AppComponent.displayName = 'AppComponent';

function mapStateToProps(state) {
  const props = { activities: state.activities };
  return props;
}
function mapDispatchToProps(dispatch) {
  const actions = {
    getGroupings,
    getItems,
    clear,
  };
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);
